import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
  DialogTrigger,
  type DialogContentProps,
  type DialogProps,
} from "#ui/dialog";

interface CheckImageDialogProps extends Omit<DialogProps, "children"> {
  children: DialogContentProps["children"];
}

export function CheckImageDialog({
  children,
  ...props
}: CheckImageDialogProps) {
  return (
    <Dialog {...props}>
      <DialogTrigger aria-label="View detail">{children}</DialogTrigger>
      <DialogPortal>
        <DialogOverlay className="bg-shade-2" />
        <DialogContent variant="center" className="max-w-dvw max-h-dvh">
          <DialogDescription className="sr-only">
            Check detail
          </DialogDescription>
          <DialogClose aria-label="Close detail">{children}</DialogClose>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
